<div class="app-overlay">
  <p>{{overlayText}}</p>
</div>
